import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { BooklistAggrigatorModel } from '@app/pages/booklists/models/booklist-aggrigator-model';
import { EImageType, ImagePipe } from '@shared/pipes/image.pipe';

@Component({
  selector: 'beh-share-book-list-dialog',
  imports: [
    ImagePipe
],
  templateUrl: './share-book-list-dialog.component.html',
  styleUrl: './share-book-list-dialog.component.scss'
})
export class ShareBookListDialogComponent {
  data = inject<BooklistAggrigatorModel>(MAT_DIALOG_DATA);

  imageType = EImageType
}
